import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class NovaMatIconRegistryService {
    constructor(private _matIconRegistry: MatIconRegistry, private _domSanitizer: DomSanitizer) {}

    addSvgIcon(iconName: string, iconPath: string): MatIconRegistry {
        return this._matIconRegistry.addSvgIcon(iconName, this._domSanitizer.bypassSecurityTrustResourceUrl(iconPath));
    }
}
